import React, { createContext, useContext, useEffect, useState } from 'react';
import { useWindowSize } from '@equinor/opt-ui-core';
import { LocalStorageKeys } from 'Utils/localStorage';
// Constants
const DefaultColumnsNumber = 2;
// Methods
const getColumnCount = (windowWidth) => {
    // breakpoints
    if (windowWidth > 1450)
        return 2;
    if (windowWidth < 1450 && windowWidth > 1000)
        return 1;
    if (windowWidth < 1000 && windowWidth > 800)
        return 2;
    return 1;
};
// --- layout persist
const setStoredLayout = (columnsNumber) => {
    localStorage.setItem(LocalStorageKeys.TAGS_SUB_PANEL_CARDS_LAYOUT, String(columnsNumber));
};
const getStoredLayout = () => parseInt(localStorage.getItem(LocalStorageKeys.TAGS_SUB_PANEL_CARDS_LAYOUT));
const getInitialLayout = () => {
    const columnsNumber = getStoredLayout();
    if (Number.isNaN(columnsNumber))
        return DefaultColumnsNumber;
    return columnsNumber;
};
// Context
const TagsCardsLayoutContext = createContext(null);
// Provider Component
const CardsLayoutProvider = ({ children }) => {
    const [currentLayout, setCurrentLayout] = useState(getInitialLayout());
    // Layout change on resize
    const { width: windowWidth } = useWindowSize();
    useEffect(() => {
        if (!windowWidth || currentLayout === 1)
            return;
        setCurrentLayout(getColumnCount(windowWidth));
    }, [windowWidth]);
    // Handlers
    const setLayout = (columnsNumber) => {
        setStoredLayout(columnsNumber);
        setCurrentLayout(columnsNumber);
    };
    // Render
    return (React.createElement(TagsCardsLayoutContext.Provider, { value: {
            layout: currentLayout,
            setLayout
        } }, children));
};
// Custom Hook
export const useCardsLayout = () => useContext(TagsCardsLayoutContext);
export default CardsLayoutProvider;
